import * as yup from "yup";
import { optionsStatus } from "~/pages/Editor/EditorDirectories/options";

export const schema = yup.object().shape({
  code: yup.string().required("Поле обязательно для заполнения"),
  name: yup.string().required("Поле обязательно для заполнения"),
  status: yup.object().shape({
    label: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([optionsStatus[0].label], "Поле не может быть пустым"),
    value: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
  }),
  DirectionId: yup.object().shape({
    label: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf(["Не выбрано"], "Поле не может быть пустым"),
    value: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
  }),
});
